import { render, staticRenderFns } from "./ScheduleCard.vue?vue&type=template&id=51753832&"
import script from "./ScheduleCard.vue?vue&type=script&lang=js&"
export * from "./ScheduleCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports